import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
} from 'react-bootstrap';
import translations from './translations.js';

class ResendCodeLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      resendingCode: false,
    };
  }

  handleClick = async () => {
    let {
      onClick,
    } = this.props;

    this.setState({
      resendingCode: true,
    });
    await onClick();
    this.setState({
      resendingCode: false,
    });
  }

  render() {
    let {
      resendingCode,
    } = this.state;
    let {
      language,
      onClick,
      ...rest
    } = this.props;

    let btnText = resendingCode ?
      translations('resendingCodeText', language)
      :
      translations('resendCodeText', language);

    return (
      <Button
        bsStyle="link"
        disabled={resendingCode}
        onClick={this.handleClick}
        {...rest}
      >
        {btnText}
      </Button>
    );
  }
}

ResendCodeLink.defaultProps = {
  language: 'en_US',
};

ResendCodeLink.propTypes = {
  language: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default ResendCodeLink;